import React from 'react';

const TermsOfService = () => {
  return (
    <div className="bg-[#008080] p-2 min-h-screen flex items-center justify-center font-win95">
      <div className="bg-[#C0C0C0] border-2 border-white shadow-win95 rounded-none w-full max-w-2xl">
        {/* Window Title Bar */}
        <div className="bg-gradient-to-r from-[#000080] to-[#1084D0] text-white flex justify-between p-1">
          <span className="font-bold text-sm">Terms of Service</span>
          <div className="flex space-x-1">
            <button className="win95-button">-</button>
            <button className="win95-button">□</button>
            <button className="win95-button text-red-600">✕</button>
          </div>
        </div>

        {/* Content Area */}
        <div className="p-4 space-y-4 text-black">
          <h1 className="text-2xl font-bold border-b-2 border-gray-400 pb-2">
            Terms of Service
          </h1>

          <div className="space-y-4 overflow-y-auto max-h-[500px]">
            <div>
              <h2 className="font-bold mb-2">1. Acceptance of Terms</h2>
              <p>
                By accessing and using our service, you agree to be bound by these Terms of Service. If you do not agree, please do not use our service.
              </p>
            </div>

            <div>
              <h2 className="font-bold mb-2">2. User Accounts</h2>
              <ul className="list-disc pl-6">
                <li>You must provide accurate and current information</li>
                <li>You are responsible for maintaining the confidentiality of your account</li>
                <li>You agree to accept responsibility for all activities under your account</li>
              </ul>
            </div>

            <div>
              <h2 className="font-bold mb-2">3. User Conduct</h2>
              <p>You agree not to:</p>
              <ul className="list-disc pl-6">
                <li>Use the service for any illegal or unauthorized purpose</li>
                <li>Violate any local, state, national, or international law</li>
                <li>Harass, threaten, or harm other users</li>
                <li>Upload content that is offensive, defamatory, or inappropriate</li>
              </ul>
            </div>

            <div>
              <h2 className="font-bold mb-2">4. Intellectual Property</h2>
              <p>
                All content on our service is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works without our express permission.
              </p>
            </div>

            <div>
              <h2 className="font-bold mb-2">5. Limitation of Liability</h2>
              <p>
                Our service is provided "as is" without any warranties. We shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from your use of the service.
              </p>
            </div>

            <div>
              <h2 className="font-bold mb-2">6. Modifications to Terms</h2>
              <p>
                We reserve the right to modify these Terms of Service at any time. Continued use of the service after changes constitutes acceptance of the new terms.
              </p>
            </div>

            <div>
              <h2 className="font-bold mb-2">7. Termination</h2>
              <p>
                We may terminate or suspend your account at our sole discretion, with or without notice, for any violation of these Terms of Service.
              </p>
            </div>
          </div>

          <div className="text-xs text-gray-700 text-center mt-2">
            Last Updated: {new Date().toLocaleDateString()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;